module.exports = "/assets/images/devil.png";